import { motion } from "framer-motion";

const cards = [
  "Te comparan por precio cuando deberían elegirte por valor.",
  "No reconocen diferenciales que te llevó años construir.",
  "Tu posicionamiento representa lo que fuiste, no hacia dónde vas.",
];

const ValorSobreLaMesa = () => {
  return (
    <section id="valor" className="py-24 md:py-32 bg-muted">
      <div className="container px-4">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display text-3xl md:text-5xl font-bold text-center max-w-5xl mx-auto mb-16 leading-tight"
        >
          Cuando tu empresa evoluciona pero su percepción no,{" "}
          <span className="text-primary">empieza a dejar valor sobre la mesa</span>.
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {cards.map((text, i) => (
            <motion.div
              key={text}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="rounded-2xl border border-border bg-card/60 p-8 flex items-center justify-center text-center"
            >
              <p className="font-display text-lg md:text-xl font-semibold leading-snug">{text}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="font-display text-xl md:text-2xl text-center max-w-3xl mx-auto mt-16 text-muted-foreground"
        >
          El deseo es simple: que el mercado vea, entienda y valore la empresa que realmente construiste.
        </motion.p>
      </div>
    </section>
  );
};

export default ValorSobreLaMesa;
